import PropTypes from 'prop-types';
import React, { createContext, useState, useEffect } from 'react';

export const FormTaskContext = createContext();

export const FormTaskContextProvider = (props) => {
  // Task Process Instance
  const [processInstanceId, setProcessInstanceId] = useState(null);

  // CustomSelect States
  const [csoptions, setCSOptions] = useState([]);
  const [csselected, setCSSelected] = useState([]);
  const [hiddenItems, setHiddenItems] = useState([]);

  // Tab States
  const [activeTab, setActiveTab] = useState(0);

  // FilesUpload States
  const [files, setFiles] = useState([]);
  const [tableFiles, setTableFiles] = useState([]);
  const [editFile, setEditFile] = useState([]);

  // DatePickers States
  const [datePickers, setDatePickers] = useState([]);

  // Action Column State
  const [actionRows, setActionRows] = useState([]);

  // Variables
  const [variables, setVariables] = useState([]);

  const [clearContext, setClearContext] = useState(false);

  const [disableSaveForm, setDisableSaveForm] = useState(false);

  // ------------------------------------------- //
  // ---------- Side Effects Handlers ---------- //
  // ------------------------------------------- //

  useEffect(() => {
    if (clearContext) {
      setCSOptions([]);
      setCSSelected([]);
      setHiddenItems([]);
      setActiveTab(0);
      setFiles([]);
      setTableFiles([]);
      setEditFile([]);
      setDatePickers([]);
      setActionRows([]);
      setVariables([]);
      setClearContext(false);
      setProcessInstanceId(null);
    }
  }, [clearContext]);

  // ------------------------------------------- //
  // ----------------- Return ------------------ //
  // ------------------------------------------- //

  return (
    <FormTaskContext.Provider
      value={{
        csoptions,
        setCSOptions,
        csselected,
        setCSSelected,
        activeTab,
        setActiveTab,
        files,
        setFiles,
        tableFiles,
        setTableFiles,
        datePickers,
        setDatePickers,
        actionRows,
        setActionRows,
        editFile,
        setEditFile,
        setClearContext,
        processInstanceId,
        setProcessInstanceId,
        disableSaveForm,
        setDisableSaveForm,
        variables,
        setVariables,
        hiddenItems,
        setHiddenItems,
      }}
    >
      {props.children}
    </FormTaskContext.Provider>
  );
};

FormTaskContextProvider.propTypes = {
  children: PropTypes.node,
};
